/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Permission } from './Permission';
import {
    PermissionFromJSON,
    PermissionFromJSONTyped,
    PermissionToJSON,
} from './Permission';

/**
 * 
 * @export
 * @interface LogisticsUser
 */
export interface LogisticsUser {
    /**
     * 
     * @type {string}
     * @memberof LogisticsUser
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LogisticsUser
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof LogisticsUser
     */
    nickname: string;
    /**
     * 
     * @type {Array<Permission>}
     * @memberof LogisticsUser
     */
    permissions: Array<Permission>;
}

/**
 * Check if a given object implements the LogisticsUser interface.
 */
export function instanceOfLogisticsUser(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "nickname" in value;
    isInstance = isInstance && "permissions" in value;

    return isInstance;
}

export function LogisticsUserFromJSON(json: any): LogisticsUser {
    return LogisticsUserFromJSONTyped(json, false);
}

export function LogisticsUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogisticsUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'],
        'nickname': json['nickname'],
        'permissions': ((json['permissions'] as Array<any>).map(PermissionFromJSON)),
    };
}

export function LogisticsUserToJSON(value?: LogisticsUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'email': value.email,
        'nickname': value.nickname,
        'permissions': ((value.permissions as Array<any>).map(PermissionToJSON)),
    };
}

